// ============================================================================
// Frontend Env Clean Helper — BOM + whitespace strip dari import.meta.env values
// ============================================================================
// Mirror api/_envClean.js (backend equivalent). Vercel UI env input field kadang
// save BOM (U+FEFF) leading kalau paste dari source dengan UTF-8-BOM encoding.
// Result: URL malformed di runtime → fetch URL jadi `<BOM>https:/...` → 404.
//
// Per Andra debug 18 Mei: storage.js bootstrapHFFromSupabase fire POST ke
// `/%EF%BB%BFhttps:/quantum2026ops-kes-cybercity.hf.space/import-embeddings` 404.
//
// Usage:
//   import { cleanEnv } from './envClean';
//   const HF_URL = cleanEnv(import.meta.env.VITE_HF_SPACE_URL) || 'fallback';
// ============================================================================

/**
 * Strip BOM (U+FEFF) leading + trim whitespace dari env value.
 * @param {string|undefined} value
 * @returns {string} cleaned value, empty string kalau missing
 */
export function cleanEnv(value) {
  if (!value) return '';
  return String(value).replace(/^﻿/, '').trim();
}
